import { useEffect, useState } from "react";
import { NavBar } from "../../components/NavBar";
import { useCompany } from "../../hooks/useCompany";
import { FiLink, FiMapPin, FiMessageCircle, FiShoppingBag } from "react-icons/fi";
import { api } from "../../api/api";
import { Toast } from "../../utils/Toast";
import { useIntegrationWhatsApp } from "../../hooks/useIntegrationWhatsApp";
import "./style.css";
import { FaYoutube } from 'react-icons/fa'
import "../admin.css";

export function Integration() {
  const { getQrCode, qrCode, restartIntegration, create } =
    useIntegrationWhatsApp();
  const { configurations, updateConfiguration, company, updatedComapny } =
    useCompany();

  const [improvingMessageAccepted, setImprovingMessageAccepted] = useState(false);
  const [improvingMessageSendDelivery, setImprovingMessageSendDelivery] = useState(false);
  const [imporvingMessageAvailableWithdrawal, setImporvingMessageAvailableWithdrawal] = useState(false);
  const [improvingMessageSendReview, setImprovingMessageSendReview] = useState(false);

  const [state, setState] = useState({
    idStore: configurations.idStore ?? "",
    googleKey: configurations.googleKey ?? "",
  });
  const [integrationWhatsApp, setIntegrationWhatsApp] = useState({
    host: "",
    messageAccepted: "",
    messageSendDelivery: "",
    messageAvailableWithdrawal: "",
    messageSendReview: "",
    isBot: false,
  });

  useEffect(() => {
    if (configurations?.id) {
      setState({
        idStore: configurations.idStore ?? "",
        googleKey: configurations.googleKey ?? "",
      });
    }
  }, [configurations]);

  async function saveKeys() {
    updateConfiguration({ ...state });
    await api.post("/configurations", state);
    Toast.success();
  }

  async function saveIntegrationWhatsApp() {
    await api.post(`/integration-whatsapp`, integrationWhatsApp);
    Toast.success();
  }

  async function getIntegrationWhatsApp() {
    const response = await api.get(`/integration-whatsapp`);
    setIntegrationWhatsApp({
      host: response.data[0]?.host ?? "",
      messageAccepted: response.data[0]?.messageAccepted ?? "",
      messageSendDelivery: response.data[0]?.messageSendDelivery ?? "",
      messageAvailableWithdrawal: response.data[0]?.messageAvailableWithdrawal ?? "",
      messageSendReview: response.data[0]?.messageSendReview ?? "",
      isBot: response.data[0]?.isBot ?? false,
    });
  }

  const melhorarMensagemComIA = async (key) => {
    const msg = integrationWhatsApp[key];
    if (!msg?.trim()) {
      Toast.warning("Preencha a mensagem antes de melhorar com IA.");
      return;
    }

    try {
      switch (key) {
        case "messageAccepted":
          setImprovingMessageAccepted(true);
          break;
        case "messageSendDelivery":
          setImprovingMessageSendDelivery(true);
          break;
        case "messageSendReview":
          setImprovingMessageSendReview(true);
          break;
        case "messageAvailableWithdrawal":
          setImporvingMessageAvailableWithdrawal(true);
          break;
        default:
          break;
      }

      const { data } = await api.post("/campanha/improve-message", {
        message: msg,
      });

      const improvedMessage =
        data?.message || data?.improvedMessage || data?.text || data;

      if (typeof improvedMessage === "string" && improvedMessage.trim()) {
        setIntegrationWhatsApp((prev) => ({ ...prev, [key]: improvedMessage }));
        Toast.success("Mensagem melhorada com sucesso.");
        return;
      }

      Toast.warning("Não foi possível obter uma mensagem melhorada.");
    } catch (error) {
      Toast.warning("Erro ao melhorar mensagem com IA.");
    } finally {
      switch (key) {
        case "messageAccepted":
          setImprovingMessageAccepted(false);
          break;
        case "messageSendDelivery":
          setImprovingMessageSendDelivery(false);
          break;
        case "messageSendReview":
          setImprovingMessageSendReview(false);
          break;
        case "messageAvailableWithdrawal":
          setImporvingMessageAvailableWithdrawal(false);
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    getIntegrationWhatsApp();
  }, []);

  return (
    <>
      <NavBar>
        <main className="admin-page integration-page">
          <header className="admin-page-header"><div><h1>Integrações</h1><p>Conecte seus canais e automatize a operação do estabelecimento</p></div><FiLink size={21} /></header>

          <section className="admin-surface integration-workspace">
          <ul className="nav nav-tabs integration-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                <FiShoppingBag /> iFood
              </button>
            </li>
            <>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  <FiMapPin /> Google Maps
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="whatsapp-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#whatsapp"
                  type="button"
                  role="tab"
                  aria-controls="whatsapp"
                  aria-selected="false"
                >
                  <FiMessageCircle /> WhatsApp
                </button>
              </li>

              {/* <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="payment-online-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#payment-online"
                  type="button"
                  role="tab"
                  aria-controls="payment-online"
                  aria-selected="false"
                >
                  Pagamento online
                </button>
              </li> */}
            </>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="integration-panel integration-setup-panel">
                <div className="integration-panel-heading"><span><FiShoppingBag /></span><div><h2>iFood</h2><p>Receba e gerencie os pedidos do marketplace no mesmo painel</p></div></div>
                <div className="integration-description">
                  Faça a integração do seu Unledu Pedidos com o seu Ifood.
                  <br />
                  Gerencie todos os seus pedidos por aqui! Centralize os
                  atendimentos, ganhe tempo e a satisfação dos seus clientes.
                  Para realizar integração, basta seguir os passos: <br />
                  <br />1 - Acessar o Portal do Parceiro (
                  <a
                    href="https://portal.ifood.com.br/merchant/profile"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Acessar
                  </a>
                  ) <br />
                  2 - Acesse a área Minha Loja <br />
                  3 - Copie o ID da loja e cole abaixo <br />
                  4 - Ao salvar, clique neste{" "}
                  <a
                    href="https://portal.ifood.com.br/apps/f8b2c440-a010-4609-8e0d-feea08a6148c/details"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Link
                  </a>{" "}
                  e será direcionado para os apps do iFood, onde poderá aceitar
                  a integração no aplicativo.
                </div>
                <div className="mt-4">
                  <label htmlFor="ifood-store-id">Código da loja no iFood</label>
                  <input
                    id="ifood-store-id"
                    className="form-control"
                    value={state?.idStore ?? ""}
                    onChange={(e) =>
                      setState({ ...state, idStore: e.target.value })
                    }
                    type="text"
                  />

                  <button
                    className="admin-primary-button mt-3"
                    onClick={() => saveKeys()}
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="integration-panel integration-setup-panel">
                <div className="integration-panel-heading"><span><FiMapPin /></span><div><h2>Google Maps</h2><p>Calcule distâncias e gere rotas com maior precisão</p></div></div>
                <div className="integration-description">
                  Faça a integração do seu Unledu Pedidos com o seu Google
                  Maps. <br />
                  Calcule com precisão o seu frete por distância percorrida.
                  Além disso, com essa integração você pode gerar para o seu
                  entregador a MELHOR ROTA.
                  <br />
                  Ganhe agilidade e diminua custos.
                  <br />
                  <br />1 - Acesse o Google Maps e faça o cadastro (
                  <a
                    href="https://developers.google.com/maps?hl=pt-br"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Acessar
                  </a>
                  ) <br />
                  2 - Após realizar o cadastro, dentro do painel acesse
                  Credenciais <br />
                  3 - Nesta tela clique em (+Criar Credenciais) e selecione
                  Chave de API <br />
                  4 - Copie e cole abaixo
                </div>
                <div className="mt-4">
                  <label htmlFor="google-maps-key">Chave da API do Google Maps</label>
                  <input
                    id="google-maps-key"
                    className="form-control"
                    value={state?.googleKey ?? ""}
                    onChange={(e) =>
                      setState({ ...state, googleKey: e.target.value })
                    }
                    type="text"
                  />

                  <button
                    className="admin-primary-button mt-3"
                    onClick={() => saveKeys()}
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="whatsapp"
              role="tabpanel"
              aria-labelledby="whatsapp-tab"
            >
              <div className="integration-panel integration-whatsapp-panel">
                <div className="integration-panel-heading"><span><FiMessageCircle /></span><div><h2>WhatsApp</h2><p>Configure mensagens automáticas para cada etapa do pedido</p></div><button className="integration-help-button" onClick={() => window.open('https://youtu.be/FmtpUMFKXmM', '_blank')}><FaYoutube /> Ver tutorial</button></div>
                <p className="integration-description mb-0">
                  Automatize o seu atendimento com esta integração. Personalize
                  as suas mensagens de acordo com o seu delivery. Agora, ao
                  fazer a alteração de status do pedido, o seu cliente já recebe
                  uma mensagem automaticamente. Prático, rápido e eficiente!
                </p>

                <div className="mt-4 integration-variables">
                  <p className="integration-variables-title">Variáveis de uso</p>
                  - @NUMERO_PEDIDO (Número do pedido do cliente)
                  <br />
                  - @NOME_CLIENTE (Nome do cliente no pedido) <br />
                  - @CONTATO_CLIENTE (Contato do cliente no pedido) <br />
                  - @LINK (Link do pedido) <br />
                </div>

                <div className="row mt-3">
                  <div className="mb-3 col-sm-6 integration-message-card">
                    <label
                      htmlFor="message-accepted"
                      className="form-label"
                    >
                      Mensagem de aceite do pedido.
                    </label>
                    <textarea
                      className="form-control integration-textarea"
                      value={integrationWhatsApp.messageAccepted}
                      onChange={(e) => {
                        setIntegrationWhatsApp({
                          ...integrationWhatsApp,
                          messageAccepted: e.target.value,
                        });
                      }}
                      style={{}}
                      maxLength={500}
                      id="message-accepted"
                      rows="7"
                    ></textarea>

                    <button
                      className="integration-ai-button mt-2"
                      type="button"
                      onClick={() => melhorarMensagemComIA('messageAccepted')}
                      disabled={improvingMessageAccepted}
                    >
                      {improvingMessageAccepted ? "Melhorando..." : "Melhorar mensagem com IA"}
                    </button>
                  </div>
                  <div className="mb-3 col-sm-6 integration-message-card">
                    <label
                      htmlFor="message-delivery"
                      className="form-label"
                    >
                      Mensagem de enviado para entrega.
                    </label>
                    <textarea
                      className="form-control integration-textarea"
                      value={integrationWhatsApp.messageSendDelivery}
                      onChange={(e) => {
                        setIntegrationWhatsApp({
                          ...integrationWhatsApp,
                          messageSendDelivery: e.target.value,
                        });
                      }}
                      style={{}}
                      maxLength={500}
                      id="message-delivery"
                      rows="7"
                    ></textarea>
                    <button
                      className="integration-ai-button mt-2"
                      type="button"
                      onClick={() => melhorarMensagemComIA('messageSendDelivery')}
                      disabled={improvingMessageSendDelivery}
                    >
                      {improvingMessageSendDelivery ? "Melhorando..." : "Melhorar mensagem com IA"}
                    </button>
                  </div>
                  <div className="mb-3 col-sm-6 integration-message-card">
                    <label
                      htmlFor="message-withdrawal"
                      className="form-label"
                    >
                      Mensagem de disponivel para retirada.
                    </label>
                    <textarea
                      className="form-control integration-textarea"
                      value={integrationWhatsApp.messageAvailableWithdrawal}
                      onChange={(e) => {
                        setIntegrationWhatsApp({
                          ...integrationWhatsApp,
                          messageAvailableWithdrawal: e.target.value,
                        });
                      }}
                      style={{}}
                      maxLength={500}
                      id="message-withdrawal"
                      rows="7"
                    ></textarea>
                    <button
                      className="integration-ai-button mt-2"
                      type="button"
                      onClick={() => melhorarMensagemComIA('messageAvailableWithdrawal')}
                      disabled={imporvingMessageAvailableWithdrawal}
                    >
                      {imporvingMessageAvailableWithdrawal ? "Melhorando..." : "Melhorar mensagem com IA"}
                    </button>
                  </div>
                  <div className="mb-3 col-sm-6 integration-message-card">
                    <label
                      htmlFor="message-review"
                      className="form-label"
                    >
                      Mensagem de avaliação.
                    </label>
                    <textarea
                      className="form-control integration-textarea"
                      value={integrationWhatsApp.messageSendReview}
                      onChange={(e) => {
                        setIntegrationWhatsApp({
                          ...integrationWhatsApp,
                          messageSendReview: e.target.value,
                        });
                      }}
                      maxLength={500}
                      style={{}}
                      id="message-review"
                      rows="7"
                    ></textarea>
                    <button
                      className="integration-ai-button mt-2"
                      type="button"
                      onClick={() => melhorarMensagemComIA('messageSendReview')}
                      disabled={improvingMessageSendReview}
                    >
                      {improvingMessageSendReview ? "Melhorando..." : "Melhorar mensagem com IA"}
                    </button>
                  </div>
                </div>


                <div className="mt-4 mb-4 border pt-3 pb-3 ps-3 pe-3 rounded integration-bot-box">
                  <div className="form-check form-switch integration-switch mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={integrationWhatsApp.isBot}
                      onChange={(e) =>
                        setIntegrationWhatsApp({
                          ...integrationWhatsApp,
                          isBot: e.target.checked,
                        })
                      }
                      id="flexCheckDefault"
                    />
                    <label htmlFor="flexCheckDefault" className="form-check-label">
                      Habilitar bot de atendimento?
                    </label>
                  </div>

                  <i className="integration-hint">Para ativar o bot de atendimento, favor entrar em contato.</i>
                </div>

                <div className="integration-whatsapp-actions">
                  <button
                    className="admin-primary-button"
                    onClick={() => saveIntegrationWhatsApp()}
                  >
                    Salvar registro
                  </button>
                  <div className="integration-whatsapp-secondary-actions">
                    <button
                      className="admin-secondary-button"
                      onClick={() => restartIntegration()}
                    >
                      Desconectar
                    </button>
                    <button
                      className="admin-secondary-button"
                      onClick={() => getQrCode()}
                    >
                      Pegar QR Code
                    </button>
                    <button
                      className="admin-secondary-button"
                      onClick={() => create()}
                    >
                      Conectar
                    </button>
                  </div>
                </div>

                <div
                  className="mt-3 integration-qrcode-wrapper"
                  style={{ display: qrCode ? "block" : "none" }}
                >
                  <img
                    src={`data:image/png;base64, ${qrCode}`}
                    alt=""
                    width={250}
                    height={250}
                  />
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="payment-online"
              role="tabpanel"
              aria-labelledby="payment-online-tab"
            >
              <div className="col-sm-12 mt-2 p-3">
                <div className="mt-4 alert alert-info">
                  <strong>Como funciona:</strong>
                  <br />
                  • Quando um cliente escolher Online como forma de pagamento,
                  um QR Code PIX será gerado automaticamente
                  <br />
                  • O cliente escaneia o código e efetua o pagamento
                  <br />
                  • O sistema recebe a confirmação do pagamento em tempo real
                  <br />• O pedido é atualizado automaticamente após a
                  confirmação
                  <br />
                  <br />
                  <strong>
                    OBS: É necessário ter uma conta ativa na Abacate Pay para
                    utilizar e os valores da taxa de transação serão cobrados
                    conforme o plano contratado na Abacate Pay (hoje R$ 0,80
                    centavos por transação).
                  </strong>
                </div>

                <div>
                  Faça a integração para automatizar o PIX e receber direto na
                  sua conta AbacatePay
                  <br />
                  Para realizar integração, basta seguir os passos para abrir
                  sua conta e gerar o token: <br />
                  <br />1 - Acessar o link abaixo (
                  <a
                    href="https://www.abacatepay.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Acessar
                  </a>
                  ) <br />
                  2 - Clique em Cadastra-se realize o processo normal de
                  cadastro <br />
                  3 - Após realizar o cadastro, na tela inicial na parte
                  superiro tem a oção que vc pode alterar de Conta teste e Conta
                  de produção <br />
                  4 - Após alterar para modo de Produção, clique em *API" e
                  depois em *Criar chave API* <br />
                  5 - Após gerar a chave, copie e cole abaixo <br />
                </div>
                <div className="mt-3">
                  <label htmlFor="">API Key do Abacate Pay</label>
                  <input
                    className="form-control form-control-sm"
                    value={company?.gatewayPagamento?.apiKey || ""}
                    onChange={(e) =>
                      updatedComapny({
                        ...company,
                        gatewayPagamento: {
                          name: "abacatepay",
                          apiKey: e.target.value,
                        },
                      })
                    }
                    type="text"
                    placeholder="Insira sua API Key do Abacate Pay"
                  />

                  <button
                    className="btn btn-sm btn-dark-blue mt-3"
                    onClick={async () => {
                      await api.post("/companies", company);
                      Toast.success("Dados salvos com sucesso!");
                    }}
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
          </section>
        </main>
      </NavBar>
    </>
  );
}
